import React from "react";
import { Dialog } from "@headlessui/react";
import { IoMdClose } from "react-icons/io";


const DisclaimerModal = ({ isOpen, onClose }) => {
    
    return (
        <Dialog open={isOpen} onClose={onClose} className="fixed inset-0 z-50 overflow-y-auto">
            <div className="flex items-center justify-center min-h-screen p-4 bg-black bg-opacity-70">
                <Dialog.Panel className="relative w-full max-w-4xl h-[90vh] mx-auto bg-white rounded-lg p-6">
                    <button
                        onClick={onClose}
                        className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
                    >
                        <IoMdClose className="w-6 h-6" />
                    </button>

                    <h1 className="text-2xl text-center text-blue-800 font-semibold">DISCLAIMER</h1>

                    <div className="italic mt-5 text-sm leading-6 space-y-6 max-h-[70vh] overflow-y-auto px-2">
                        <section>
                            <h2 className="text-lg font-medium">1. General Disclaimer</h2>
                            <ul className="list-disc ml-6">
                                <li>Services are for research professionals and clients only.</li>
                                <li>Unauthorized access is prohibited and subject to legal action.</li>
                                <li>We do not guarantee complete accuracy of all content.</li>
                            </ul>
                        </section>

                        <section>
                            <h2 className="text-lg font-medium">2. Confidentiality & Data Privacy</h2>
                            <ul className="list-disc ml-6">
                                <li>All submitted documents are securely stored and handled confidentially.</li>
                                <li>We do not share data without explicit client consent.</li>
                                <li>Clients must avoid uploading personal identifiers unless required.</li>
                            </ul>
                        </section>

                        <section>
                            <h2 className="text-lg font-medium">3. Service Scope & Limitations</h2>
                            <ul className="list-disc ml-6">
                                <li>Scope includes project updates, document sharing, and research consulting.</li>
                                <li>We do not provide medical, legal, or financial advice.</li>
                                <li>All interpretation of results is the client’s responsibility.</li>
                            </ul>
                        </section>

                        <section>
                            <h2 className="text-lg font-medium">4. Intellectual Property</h2>
                            <ul className="list-disc ml-6">
                                <li>All tools, methods, and reports remain the property of MyResearchRoom unless otherwise stated.</li>
                                <li>Use of resources is permitted only for internal, agreed-upon purposes.</li>
                            </ul>
                        </section>

                        <section>
                            <h2 className="text-lg font-medium">5. Legal Compliance</h2>
                            <ul className="list-disc ml-6">
                                <li>Services are governed by the laws of India.</li>
                                <li>Legal jurisdiction lies with the courts in [Your City].</li>
                            </ul>
                        </section>

                        <section>
                            <h2 className="text-lg font-medium">6. Support</h2>
                            <ul className="list-disc ml-6">
                                <li>
                                    For help, email us at <span className="font-medium underline">info@myresearchroom.com</span> or call <span className="font-medium underline">+91- 8767897950</span>.
                                </li>
                            </ul>
                        </section>

                        <p className="italic underline text-center text-gray-500 mt-4">
                            By using this platform, you agree to our terms and conditions.
                        </p>
                    </div>
                </Dialog.Panel>
            </div>
        </Dialog>
    );
};

export default DisclaimerModal;
